import React, { useState, useEffect } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { Link } from "react-router-dom"
import { getUrlListA } from "./Url"
import { GoStack } from "react-icons/go";
import styles from './PresenterProject.module.css'
import ProjectLinkGroup from "./ProjectLinkGroup";
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'

function PresenterProject({project_name, project_description, repos, language}){
    const [markdown, setMarkdown] = useState('');
    const [loading, setLoading] = useState(true);
    const ui = getData('ui', language)
    
    const githubRepo = repos.find(e => e.repoTitle.toUpperCase() === 'GITHUB');
    let readmeUrl = '';
    
    if (githubRepo) {
        readmeUrl = githubRepo.repoUrl.replace('github.com', 'raw.githubusercontent.com');
        readmeUrl = readmeUrl + '/main/README.md';
    }

    useEffect(() => {
        if (readmeUrl) {
            fetch(readmeUrl)
                .then(res => res.text())
                .then(setMarkdown)
                .catch(console.error)
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [readmeUrl]);

    const loadingText = language === 'eng' 
        ? `Loading README from ${readmeUrl}...` 
        : `Загрузка README из ${readmeUrl}...`;
    
    const descriptionText = language === 'eng'
        ? `Description from ${readmeUrl}`
        : `Описание из ${readmeUrl}`;

    const aboutProjectLoading = <div>{loadingText}</div>
    const aboutProjectInfo = <>
        <p>{descriptionText}</p>
        <div className={styles.readMe}>
            <Markdown remarkPlugins={[remarkGfm]}>
                {markdown}
            </Markdown>
        </div>
    </>;

    return (
        <>
            <h1 className={styles.project_name}>{project_name}</h1>
            <p className={styles.project_description}>{project_description}</p>
            <ProjectLinkGroup repos={repos} language={language}></ProjectLinkGroup>
            <Link to={getUrlListA('project')} title={ui.projects}>
                <GoStack /> {ui.projects}
            </Link>
            {loading ? aboutProjectLoading : aboutProjectInfo}
        </>
    )
}

export default PresenterProject